import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { LoginNavigationService } from '../login-navigation/login-navigation.service';
import { AuthManagerService } from '../auth-manager/auth-manager.service';

@Injectable({ providedIn: 'root' })
export class B2CLoginInitGuard implements CanActivate {
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private authManager: AuthManagerService,
    private loginNavigationService: LoginNavigationService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  async canActivate(): Promise<boolean> {
    if (!this.isBrowser) {
      return true;
    }

    const fragment = window.location.hash.substring(1);
    const params = new URLSearchParams(fragment);
    const idToken = params.get('id_token');

    if (idToken) {
      this.authManager.loginWithB2C(idToken).subscribe({
        next: () => {
          this.loginNavigationService.checkRegistrationProgressOnNextNavigation = true;
          this.router.navigate(['/dashboard']);
        },
        error: (err) => console.error('Backend login failed:', err),
      });

      window.history.replaceState({}, document.title, window.location.pathname);
    }

    return true;
  }
}
